/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {LookupGatewayMerchantDataRequest} from '@cash-web/protos/squareup/roster/gateway.pb'
import {LookupGatewayMerchantDataResponse} from '@cash-web/protos/squareup/roster/gateway.pb'


export const lookup = (request: LookupGatewayMerchantDataRequest, options?: CashRequestOptions) => post<LookupGatewayMerchantDataRequest, LookupGatewayMerchantDataResponse>("/2.0/cash/lookup", request, {...options, rejectOnError: true })